module.exports = __webpack_public_path__ + "static/12-rules-for-life-681b8d2352900ff053b3fce69a9a3613.jpg";